import { Helmet } from "react-helmet-async";
import { useEffect, useState } from "react";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { Container, Tab, Tabs } from "react-bootstrap";
import { useAlert } from "../../../context/AlertContext";
import { useLoading } from "../../../context/LoadingContext";
import { useWebsiteName } from "../../../context/WebsiteNameContext";
import { findItemInArray } from "../../../utils/ManageArray";
import {
  addEditServiceRequest,
  getServiceRequest
} from "../../../commons/ServiceRequest";
import handleChangeWebsiteTab from "../../../commons/ChangeWebsiteTab";
import WorkingPlanForm from "../../../components/PMWork/CreatePlanPM/WorkingPlanForm";
import WorkOrderForm from "../../../components/PMWork/CreatePlanPM/WorkOrderForm";
import WorkOrderDetailsForm from "../../../components/PMWork/CreatePlanPM/WorkOrderDetailsForm";
import TicketNumberForm from "../../../components/PMWork/CreatePlanPM/TicketNumberForm";
import EditPMNumberStatusForm from "../../../components/PMWork/CreatePlanPM/EditPMNumberStatusForm";
import PMNosService from "../../../services/pmno.service";

export default function EditCreatePlanPM() {
  const navigate = useNavigate();
  const { id } = useParams();
  const { state } = useLocation();
  const { showAlert } = useAlert();
  const { setLoading } = useLoading();
  const { websiteName, setWebsiteName } = useWebsiteName();
  const [editData, setEditData] = useState(null);

  const handleSubmitWorkingPlan = (data) => {
    data && console.log(data);
  };

  const formComponentMap = {
    "": <WorkOrderForm onSubmitCallback={handleSubmitWorkingPlan} />,
    order: <WorkOrderDetailsForm onSubmitCallback={handleSubmitWorkingPlan} />,
    ticket: <TicketNumberForm onSubmitCallback={handleSubmitWorkingPlan} />
  };

  useEffect(() => {
    handleChangeWebsiteTab({
      key: state?.name || "create",
      setWebsiteName,
      tabNames: {
        create: "แก้ไขสถานะหมายเลข PM",
        working_plan: "แก้ไขวันเข้าทำงาน PM",
        ticket: "นำเข้าหมายเลขงานลูกค้า (Ticket No.)",
        order: "สร้างใบสั่งงาน Service Request",
        request: "สร้างใบสั่งงาน Service Request",
        work_order: "สร้างใบสั่งงาน Service Request"
      }
    });
    if (["create", "working_plan"].includes(state?.name)) {
      getServiceRequest({
        showAlert,
        setLoading,
        serviceRequest: PMNosService.getAllPMNos(),
        callback: (res) => setEditData(findItemInArray(res, "Id", id))
      });
    }
  }, []);

  return (
    <>
      <Helmet>
        <title>{websiteName}</title>
        <meta name="description" content="Add Create Plan PM Page" />
      </Helmet>

      <Container fluid className="p-0">
        <Tabs justify activeKey={state?.name}>
          <Tab eventKey="create" title="การสร้างแผน PM">
            {websiteName === "แก้ไขสถานะหมายเลข PM" && (
              <EditPMNumberStatusForm
                editData={editData}
                onSubmitCallback={({ data }) => {
                  const updatedData = data.map(
                    ({
                      Id,
                      PMPlan,
                      Employee,
                      createdAt,
                      createdBy,
                      updatedAt,
                      updatedBy,
                      ...item
                    }) => item
                  )?.[0];
                  addEditServiceRequest({
                    showAlert,
                    setLoading,
                    serviceRequest: PMNosService?.editPMPlanNo(id, updatedData),
                    navigated: (navi) => navi && navigate(0)
                  });
                }}
              />
            )}
          </Tab>
          <Tab eventKey="working_plan" title="กำหนดแผนเข้าทำงาน PM แต่ละสาขา">
            {websiteName === "แก้ไขวันเข้าทำงาน PM" && (
              <WorkingPlanForm
                editData={editData}
                onSubmitCallback={({ Array }) => {
                  addEditServiceRequest({
                    showAlert,
                    setLoading,
                    serviceRequest: PMNosService.editPMPlanNo(id, Array?.[0])
                    // navigated: (navi) => navi && navigate(0)
                  });
                }}
              />
            )}
          </Tab>
          <Tab eventKey="work_order" title="สร้างใบสั่งงาน Service Request">
            {websiteName === "สร้างใบสั่งงาน Service Request" &&
              formComponentMap[state?.type]}
          </Tab>
        </Tabs>
      </Container>
    </>
  );
}
